<template>
  <header>
    <div class="d-flex align-items-center justify-content-between">
      <!-- <div
        class="d-flex align-items-start justify-content-between flex-column logo"
      > -->
      <img
        src="@/assets/img/logo-org.png"
        alt="Logo"
        @click="
          $router.push({ name: 'Home', pamras: { locale: $i18n.locale } })
        "
      />
      <!-- <language-switch /> -->
      <!-- </div> -->
      <div>
        <a v-if="visiableDonation" :href="donationLink" target="_blank">
          <button>{{ $t("button.giveOnline") }}</button>
        </a>
        <button data-toggle="modal" data-target="#planModal" class="ml-3">
          {{ $t("label.planAVisit") }}
        </button>
        <button
          data-toggle="modal"
          data-target="#askQuestionModal"
          class="ml-3"
        >
          {{ $t("label.askAQuestion") }}
        </button>
      </div>
    </div>

    <plan-modal />
    <ask-a-question />
  </header>
</template>
<script>
import PlanModal from "./PlanModal";
import AskAQuestion from "./AskAQuestion";
export default {
  name: "Header",
  data: () => ({
    visiableDonation: false,
    donationLink: "",
  }),
  components: {
    PlanModal,
    AskAQuestion,
  },
  created() {
    const { donation_url } = this.$route.query;
    if (donation_url) {
      this.visiableDonation = true;
      this.donationLink = donation_url;
    }
  },
};
</script>

<style lang="scss" scoped>
header {
  padding: 24px 44px;
  img {
    height: 45px;
    cursor: pointer;
  }
  @media (min-width: 768px) {
    .logo {
      flex-direction: row !important;
      align-items: center !important;
      img {
        margin-right: 10px;
      }
    }
  }
  @media (min-width: 577px) {
    padding: 15px;
    > div {
      img {
        height: 30px;
      }
      button {
        padding: 2px 10px;
      }
    }
  }
  @media (max-width: 576px) {
    padding: 15px;
    > div {
      img {
        height: 30px;
      }
      > div {
        display: flex;
        flex-direction: column;
        button {
          margin-left: 0 !important;
          font-size: 14px;
          margin-top: 10px;
          width: 100%;
          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>
